import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ResultDisplay from 'components/resultDisplay/ResultDisplay';
import sessionExpiredImg from 'assets/images/session_expired.png';
import { buildLoginPath } from 'utils/pathBuilder';
import './SessionExpired.scss';

const SessionExpired: React.FC = () => {
  const { t } = useTranslation('session_expired');
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate(buildLoginPath());
  };

  return (
    <ResultDisplay
      title={t('title')}
      imageUrl={sessionExpiredImg}
      onNext={handleLogin}
      nextText={t('loginButton')}
      showFooter={true}
    >
      <div className="session-expired-message">
        <div>{t('message')}</div>
      </div>
    </ResultDisplay>
  );
};

export default SessionExpired;

